import React, { memo, useCallback, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCopy, faEdit,
} from '@fortawesome/free-regular-svg-icons';
import {
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import {
  ListItemIcon, ListItemText, Menu, MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';
import ListerContext from '../../context';

function CatCtxMenu({ children }) {
  const {
    ctxMenu, onHideCtxMenu, actions, permissions,
  } = useContext(ListerContext);
  const onEdit = useCallback(
    (e) => {
      onHideCtxMenu(e);
      actions.onEdit(e);
    },
    [actions, onHideCtxMenu],
  );
  const onCopy = useCallback(
    (e) => {
      onHideCtxMenu(e);
      actions.onCopy(e);
    },
    [actions, onHideCtxMenu],
  );
  const onDelete = useCallback(
    (e) => {
      onHideCtxMenu(e);
      actions.onDelete(e);
    },
    [actions, onHideCtxMenu],
  );

  return (
    <Menu
      open={ctxMenu.visible}
      onClose={onHideCtxMenu}
      anchorReference="anchorPosition"
      anchorPosition={{
        top: ctxMenu.top,
        left: ctxMenu.left,
      }}
    >
      <MenuItem onClick={onEdit} disabled={!permissions.canEdit}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faEdit} className="mr-2" />
        </ListItemIcon>
        <ListItemText>
          Змінити
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={onCopy} disabled={!permissions.canCopy}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faCopy} className="mr-2" />
        </ListItemIcon>
        <ListItemText>
          Копіювати
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={onDelete} disabled={!permissions.canDelete} sx={{ color: 'red' }}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faTrash} className="mr-2" />
        </ListItemIcon>
        <ListItemText>
          Видалити
        </ListItemText>
      </MenuItem>
      {children}
    </Menu>
  );
}

CatCtxMenu.propTypes = {
  children: PropTypes.node,
};

CatCtxMenu.defaultProps = {
  children: null,
};

export default memo(CatCtxMenu);
